import { api } from '../../lib/api'
import { reactLocalStorage } from 'reactjs-localstorage';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILED = 'LOGOUT_FAILED'
export const IMPERSONATE_END = 'IMPERSONATE_END'

export const logout = function (impersonating) {
  return function (dispatch) {
    dispatch({
      type: LOGOUT_REQUEST,
    })
    api.logout().then(logoutResponse => {
      reactLocalStorage.clear()
      if ( impersonating ) {
        dispatch({
          type: IMPERSONATE_END,
          payload: logoutResponse
        })
      } else {
        dispatch({
          type: LOGOUT_SUCCESS,
          payload: logoutResponse
        })
        dispatch({
          type: 'RESET'
        })
      }
    }).catch(error => {
      dispatch({
        type: LOGOUT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/logout.js